export enum CardBrandsEnum {
  VISA = "visa",
  AMEX = "amex",
  MASTERCARD = "mastercard",
  DINERS = "diners",
  DISCOVER = "discover",
  JCB = "jcb",
  CARNET = "carnet",
  MASTER_CARD = "masterCard",
}
